import React from "react";
import { DataTable, Table } from "@sscs/ui";
import { useSearchParams } from "react-router";
import { FILE_BROWSER_ROUTES, REPORT_PAGES_ROUTES, ROOT_FILE_PATH, TRANSFORM_LINKING, } from "../../../constants";
import { referencesPaginationUpdated, selectReferencesPagination, } from "../../../store/licensesSlice";
import { filteredByDependency } from "../../../store/sbomSlice";
import { IdentitySummary, LinkToReportTab } from "../../common";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetLicenseReferencesQuery } from "../../services/licenses.api";
import { generateFileBrowserLink, getQueryStatus } from "../../utils";
import styles from "./licenseDetails.module.scss";
const COLUMNS = [
    { id: "type", label: "Type", width: "230px" },
    { id: "name", label: "Name and version", width: "300px" },
    { id: "path", label: "File path", width: "100%" },
];
const LicenseReferences = ({ reportId, licenseId, }) => {
    var _a;
    const [searchParams] = useSearchParams();
    const dispatch = useReportDispatch();
    const pagination = useReportSelector((state) => selectReferencesPagination(state, licenseId));
    const { data = {
        match_count: 0,
        references: [],
    }, isFetching, isLoading, isError, error, } = useGetLicenseReferencesQuery({
        ui_item_id: licenseId,
        ui_id: reportId,
        pagination,
    });
    return (React.createElement(DataTable, { title: "Components and dependencies with this license", columns: COLUMNS, pagination: {
            itemCount: (_a = data === null || data === void 0 ? void 0 : data.match_count) !== null && _a !== void 0 ? _a : 0,
            pagination,
            onChange: (newPagination) => dispatch(referencesPaginationUpdated({
                id: licenseId,
                pagination: newPagination,
            })),
        }, status: getQueryStatus({
            isLoading,
            isFetching,
            isError,
            error,
            data,
        }) }, data === null || data === void 0 ? void 0 : data.references.map((item, index) => (React.createElement(Table.Row, { hover: true, key: item.id },
        React.createElement(Table.Cell, null, item.linking ? TRANSFORM_LINKING[item.linking] : "Component"),
        React.createElement(Table.Cell, null,
            React.createElement(IdentitySummary, { identity: item.identity })),
        React.createElement(Table.Cell, null,
            React.createElement(LinkToReportTab, { id: `${licenseId}-link-${index}`, to: item.type === "DEPENDENCY"
                    ? REPORT_PAGES_ROUTES.SBOM_ROUTE
                    : generateFileBrowserLink({
                        searchParams,
                        componentPath: item.path,
                        componentId: item.id,
                        fileBrowserPage: FILE_BROWSER_ROUTES.INFO_ROUTE,
                    }), key: item.id, onClick: () => {
                    if (item.type === "DEPENDENCY") {
                        dispatch(filteredByDependency({
                            id: item.id,
                            name: item.name,
                        }));
                    }
                }, color: "link", className: styles.link }, item.type === "DEPENDENCY"
                ? "View dependency"
                : !item.path
                    ? ROOT_FILE_PATH
                    : item.path)))))));
};
export default LicenseReferences;
//# sourceMappingURL=LicenseReferences.js.map